.spinner-container {
  --scale-multiplier: 1.2;
  display: flex;
  place-content: center;
  height: 100%;
  width: 100%;
  aspect-ratio: 1;
  pointer-events: none;
  mix-blend-mode: screen;
  anchor-name: --spinner;
  anchor-scope: all;
}

@keyframes spinner-pulse {
  0%,
  100% {
    scale: var(--base-scale);
  }
  50% {
    scale: calc(var(--base-scale) * var(--scale-multiplier));
  }
}

.spinner,
.spinner-overlay {
  mix-blend-mode: inherit;
  position: absolute;
  position-anchor: --spinner;
  width: anchor-size(width);
  height: anchor-size(height);
  top: anchor(top);
  left: anchor(left);
  aspect-ratio: 1;
  scale: var(--base-scale);
}
.spinner {
  --base-scale: 1.5;
}

.spinner-overlay {
  --base-scale: 1.7;
}
